import { ApplicationPaneHeader } from '../../atoms/applications/ApplicationPaneHeader';
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import './applicationPageUserInfoPane.module.scss';
import { Page, Pane, PaneBody } from '../../atoms/applications/page';
import { Loader } from '../../atoms/forms/loader';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import { SignInPane } from '../signin/SignInPane';
import { BaseApplicationPageState } from '../../../containers/application/states/BaseApplicationPageState';

type Props = {
    applicationState: BaseApplicationPageState;
};

@inject('applicationState')
@observer
export class ApplicationPageUserSignInPane extends React.Component<Props> {
    render() {
        const {
            applicationState: { name, applicationPageResource, page_key },
        } = this.props;
        if (applicationPageResource.loading) {
            return <Loader />;
        }
        return (
            <Page>
                <Pane styleName="pane">
                    <PaneBody>
                        <ApplicationPaneHeader plan={name} />
                        <SignInPane
                            redirectUrl={V3Routes.applicationPageUserSummary(page_key).stringify()}
                            supportNewUser={false}
                            onNewUserPreferred={() =>
                                GlobalStatesV3.routing.push(V3Routes.applicationPageUserInfo(page_key).stringify())
                            }
                        />
                    </PaneBody>
                </Pane>
            </Page>
        );
    }
}
